import axios from "axios"

const state = {
    total_orders: 0,
    total_amount: 0,
    amount_by_status: {
        pending: 0,
        processing: 0,
        paid: 0,
        cancelled: 0,
        failed: 0
    },
    count_by_status: {
        pending: 0,
        processing: 0,
        paid: 0,
        cancelled: 0,
        failed: 0
    },
    rate: null
}

const getters = {
    StateTotalOrders: (state)        => state.total_orders,
    StateTotalAmount: (state)        => state.total_amount,
    StateAmountByStatus: (state)     => state.amount_by_status,
    StateCountByStatus: (state)      => state.count_by_status,
    StateRate: (state)               => state.rate
}

const actions = {
    async ActionGetStat({ commit, rootState }, user) {
        try {
            let res = await axios.get("/api/personal/stat/").then(res => res.data)
            if (res && res.result && res.data) {
                try { await commit("setStat", res.data) } catch { }
                return { result: true, data: res.data }
            } else {
                return { result: false, error: (res.error) ? res.error : null, message: (res.message) ? res.message : null }
            }
        } catch {}
    },
    async ActionGetRate({ commit, rootState }) {
        try {
            let res = await axios.get("/api/public/rate/").then(res => res.data)
            if (res && res.result && res.data) {
                try { await commit("setRate", res.data) } catch { }
                return { result: true, data: res.data }
            } else {
                return { result: false, error: (res.error) ? res.error : null, message: (res.message) ? res.message : null }
            }
        } catch {   }
    }
}

const mutations = {
    setStat(state, stat) {
        state.total_orders = stat.total_orders
        state.total_amount = stat.total_amount
        state.amount_by_status = stat.amount_by_status
        state.count_by_status = stat.count_by_status
    },
    setRate(state, rate) {
        state.rate = rate
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}